import _InfoOutlined from "@mui/icons-material/InfoOutlined";
import { Button, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Popper } from '@mui/material';
import React from 'react';
const DataInfoPopper = _ref => {
  let {
    sx = {
      marginTop: '10px',
      marginLeft: '4px'
    }
  } = _ref;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'info-popper' : undefined;
  const handleInfo = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleGoToArticle = () => {
    window.open('https://support.fupa.net/support/solutions/articles/75000014572-welche-arten-von-profilen-gibt-es-auf-fupa-wie-kann-man-sie-verwalten-', '_blank');
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    color: "action",
    sx: sx,
    size: "small",
    onClick: handleInfo,
    "data-sentry-element": "IconButton",
    "data-sentry-source-file": "DataInfoPopper.tsx"
  }, /*#__PURE__*/React.createElement(_InfoOutlined, {
    fontSize: "small",
    "data-sentry-element": "InfoOutlined",
    "data-sentry-source-file": "DataInfoPopper.tsx"
  })), /*#__PURE__*/React.createElement(Popper, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    placement: 'bottom-end',
    "data-sentry-element": "Popper",
    "data-sentry-source-file": "DataInfoPopper.tsx"
  }, /*#__PURE__*/React.createElement(Paper, {
    sx: {
      maxWidth: '360px',
      marginLeft: '1rem'
    },
    elevation: 2,
    "data-sentry-element": "Paper",
    "data-sentry-source-file": "DataInfoPopper.tsx"
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    sx: {
      fontSize: '1rem'
    },
    "data-sentry-element": "DialogTitle",
    "data-sentry-source-file": "DataInfoPopper.tsx"
  }, "Woher stammen die Daten?"), /*#__PURE__*/React.createElement(DialogContent, {
    sx: {
      fontSize: '0.875rem'
    },
    "data-sentry-element": "DialogContent",
    "data-sentry-source-file": "DataInfoPopper.tsx"
  }, "Du hast von dir selbst ein Profil auf FuPa entdeckt, das du nicht selbst verwaltest? In unserem Hilfebereich findest du alle Informationen dar\xFCber, woher die Daten aus deinem Profil stammen."), /*#__PURE__*/React.createElement(DialogActions, {
    "data-sentry-element": "DialogActions",
    "data-sentry-source-file": "DataInfoPopper.tsx"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    onClick: handleGoToArticle,
    "data-sentry-element": "Button",
    "data-sentry-source-file": "DataInfoPopper.tsx"
  }, "Mehr Informationen")))));
};
export default DataInfoPopper;